/*
**************************************************************************
Title:          Message model
Created By:     Pankaj Arora
Created on:     05/04/2018
Description:    Format the model for messages
**************************************************************************
*/
import { User } from '../users/user.model';
import moment from 'moment';
import { uuid } from '../../utils';

export class Message {
    id: string; // unique message ID
    sentAt: any; // time message was sent/received
    author: User; // who sent it Bot or current user
    text: string; // text
    data: any; // any data mainly received from backend
    nluAttributes: any; // any nlu Attributes, useful for Lex - may be for Luis & IBM too
    actionParameters: any; // action parameters
    isError: boolean; // is this error message
    fulfilledIntent: string; // redundant
    type: string; // message type Plain or action
    showTime: boolean; // show the time
    display: any; // message display type
    tiles: any;
    list: any;
    imageUrl: string;
    liveChat:boolean;
    constructor(obj?: any) {
        // set defaults or user from the input provided
        this.id = obj && obj.id || uuid();
        this.sentAt = obj && obj.sentAt || moment();
        this.author = obj && obj.author || null;
        this.text = obj && obj.text || '';
        this.data = obj && obj.data || {};
        this.nluAttributes = obj && obj.nluAttributes || {};
        this.actionParameters = obj && obj.actionParameters || {};
        this.isError = obj && obj.isError || false;
        this.fulfilledIntent = obj && obj.fulfilledIntent || '';
        this.type = obj && obj.type || '';
        this.showTime = obj && obj.showTime || true;
        this.display = obj && obj.display || 'text';
        this.tiles = obj && obj.tiles || [];
        this.list = obj && obj.list || {};
        this.imageUrl = obj && obj.imageUrl || '';
        this.liveChat = obj && obj.liveChat || false;
    }
}
